import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";

import { PDFDialogComponent } from "src/app/signup-organization/pdf-dialog/pdf-dialog.component";
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/core/services/v2/user.service';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { EmployerService } from 'src/app/core/services/v2/employer.service';
import { UtilsService } from 'src/app/core/services/v2/utils.service';


@Component({

  selector: 'app-patient-active-plan',

  templateUrl: './patient-active-plan.component.html',

  styleUrls: ['./patient-active-plan.component.scss']

})

export class PatientActivePlanComponent implements OnInit {
  @Input() activeTab: boolean = false;

  user: any = [];
  subscriptionType: number;
  selectedType: number = 0;
  activationType: string;
  userId: number;
  // employerId: number;
  isActive: boolean;
  patientId:number;
  employerId:number;
  @Input() plan:any={};
selectedPlan: any={};
noActivePlanPatient : boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    // private employerService: EmployerService,
    private patientService:PatientService,
    private loaderService: WindowLoaderService,
    public dialog: MatDialog,
    private utils: UtilsService,
  ) {}

  ngOnInit() {
    this.getUserDetails();
    }

  getUserDetails() {
    this.loaderService.show();
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.user = userDetails;
        console.log("user", this.user);
        this.userId = userDetails.id;
        this.patientId = userDetails.patientId
        this.employerId = userDetails.employerId;

        console.log("This is userId: ", this.userId);
        console.log("This is patientId: ", this.patientId);
        console.log("This is employerId: ", this.employerId);
        this.getPatientHealthSubscriptionByEmployerId();
      },
      (error) => { console.error(error); }
    );
  }
  
  getPatientHealthSubscriptionByEmployerId() {
    this.loaderService.show();
    this.patientService.getPatientSubscriptionDetailsByPatientId(this.user.patientId).subscribe(
      (res) => {
        if (res && res.resultStatus && res.resultStatus.isSuccess) {
          if (res.result && res.result.subscriptionTypeId !== 0) {
            console.log("Subscription Details:", res.result);
  
            // Set the active status and subscriptionTypeId from the API response
            const active = res.result.active;
            this.selectedType = res.result.subscriptionTypeId;
            this.activationType = active ? "Activate" : "Deactivate";
  
            // Update the subscription plan's active status
            this.selectedPlan = res.result;
            this.noActivePlanPatient = false; // Reset the flag
  
            // this.utils.showMessageSnackBar(res.resultStatus.message || "Subscription found!", false); // Success message
          } else {
            this.noActivePlanPatient = true;
            this.utils.showMessageSnackBar("No active subscription found.", true); // Failure message
          }
        } else {
          this.noActivePlanPatient = true;
          // If isSuccess is false, display error message(s) from the API response
          const errorMessage = res.resultStatus.errorMessages ? res.resultStatus.errorMessages.join(", ") : "Failed to fetch subscription details.";
          // this.utils.showMessageSnackBar(errorMessage, true); // Show the error message
        }
  
        this.loaderService.hide();
      },
      (error) => {
        console.error("Error fetching subscription details:", error);
        this.noActivePlanPatient = true;
        this.loaderService.hide();
        this.utils.showMessageSnackBar("An error occurred while fetching subscription details.", true); // Generic error message for API failure
      }
    );
  }
  
  
    ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeTab'] && changes['activeTab']) {
      this.handleTabActivation();
    }
  }

  handleTabActivation(): void {
    console.log('My Subscriptions tab is active');
    // Your additional logic here
    this.getUserDetails();
  }



  upgradeSubscription() {
    // Close the modal programmatically
    // document.getElementById("clsUpgradeModal").click();
 // Switch to the "Subscriptions" tab
//  const medicalHistoryTab = document.getElementById('medicalHistory-tab');

//  if (medicalHistoryTab) {
//    // Use jQuery to trigger the tab switch
//    if (window['$']) {
//      const $ = window['$'];
//      $(medicalHistoryTab).tab('show'); // Bootstrap tab API with jQuery
//    } else {
//      console.error('jQuery is not available.');
//    }
//  } else {
//    console.error('Medical History tab not found.');
//  }
this.router.navigate(["/patient/subscription"]);

  }

  cancelSubscription() {
    this.loaderService.show();
    this.user.employerId = 0;  // Assign 0 to employerId

    this.activationType = "Deactivate";
    // this.isActive = false;  // Set active to false explicitly for cancelation

    // Call the service to update the subscription
    this.patientService
      .updatePatientHealthSubscription(
        this.user.patientId,
        this.user.employerId,
        this.selectedType,
        this.activationType
      )
      .subscribe(
        (result) => {
          console.log("result update", result);
          this.subscriptionType = this.selectedType;
          this.activationType = this.activationType;
          // this.isActive = result.active;  // Set the active status (false)

          console.log("subscriptionType", this.subscriptionType);
          console.log("activationType", this.activationType);
          console.log("isActive", this.isActive);

            // Call to fetch updated subscription details
            this.getUserDetails();
          this.loaderService.hide();
          document.getElementById("clsModalEmp").click();

        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        }
      );
  }

  
  openPdfDialog(type: number) {
    let data = {
      title: "Appy Health Pricing",
      url: "https://appyhealthstorage.blob.core.windows.net/customlogin/Member Enhanced Plan HEALTH.pdf", // Default URL
    };
  
    // Modify the data based on the selected plan type (URL)
    switch (type) {
      case 2:
        data = {
          title: "Appy Health Plus Pricing",
          url: "https://appyhealthstorage.blob.core.windows.net/customlogin/Member Enhanced Plan HEALTH PLUS.pdf",
        };
        break;
      case 3:
        data = {
          title: "Appy Mental Health Pricing",
          url: "https://appyhealthstorage.blob.core.windows.net/customlogin/Member Enhanced Plan MENTAL HEALTH.pdf",
        };
        break;
      case 4:
        data = {
          title: "Appy Health PREMIUM Pricing",
          url: "https://appyhealthstorage.blob.core.windows.net/customlogin/Member Enhanced Plan HEALTH PREMIUM.pdf",
        };
        break;
      default:
        console.warn('Unknown plan type:', type);
    }
  
    // Open the PDF in a new browser tab or window
    window.open(data.url, "_blank");
  }

  seePlanDetails(plan: any): void{
    console.log("plan details",plan);
    // this.router.navigate(['/agency/employee-list',employer.id]);
    this.router.navigate(['/patient/patientPlanDetails'], { state: { data: plan },  });
   
  }
  navigateToPlan1(feature: any) {
    // Assuming you're passing the planId or some identifier
    this.router.navigate(['patient/selected-plan', feature.planId]);
  }
  navigateToPlan2(planName: string) {
    console.log("planName",planName);
}
navigateToPlan(planName: string) {
  console.log("planName",planName);

  const routeMap: { [key: string]: string } = {
    'Teladoc': '/patient/teladoc',
    'Teledoc Mental Health': '/patient/teladocMentalHealth',
    'Health Advocate Solutions': '/patient/healthAdvocate',

    'NB Fitness': '/patient/nbFitness',

    'NB Rx': '/patient/nbRx',

    'Manifest Rx': '/patient/manifestRx',

    'LifeLock Essential': '/patient/lifelockEssential',

    'Lab Testing': '/patient/labTesting',

    'NB Deals': '/patient/nbDeals',

    'NB Travel': '/patient/nbTravel',

    'Pet Telehealth': '/patient/petTelehealth',

    'NB Pet Rx': '/patient/nbPetRx',

    // Add more mappings here if needed
  };

  const route = routeMap[planName];

  if (route) {
    this.router.navigate([`/${route}`]);
  } else {
    console.warn('No route found for planName:', planName);
  }
}
}